import React, { Component } from 'react';
import { fetchQuickSubsOptions } from 'api';
import { toast } from 'react-toastify';

const withQuickSubOptions = (DecoratedComponent) => {
  class WithQuickSubOptions extends Component {
    state = {
      quickVendors: [],
      quickSubTypes: [],
      quickStatuses: [],
    };

    componentDidMount() {
      this.fetchVendors();
    }

    fetchVendors = () => {
      fetchQuickSubsOptions()
        .then((res) => {
          const statusChoices = res.data.actions.GET.quick_status.choices;
          const vendorChoices = res.data.actions.GET.vendor.choices;
          const subTypesChoices =
            res.data.actions.GET.subscription_type.choices;
          const statusOptions = statusChoices.map(({ value, display_name }) => [
            value,
            display_name,
          ]);
          const vendorOptions = vendorChoices.map(({ value, display_name }) => [
            value,
            display_name,
          ]);
          const subTypesOptions = subTypesChoices.map(
            ({ value, display_name }) => [value, display_name],
          );
          this.setState({
            quickVendors: vendorOptions,
            quickSubTypes: subTypesOptions,
            quickStatuses: statusOptions,
          });
        })
        .catch(() => toast.error('Failed to load quick options'));
    };

    render() {
      const { children, ...props } = this.props;
      const { quickVendors, quickSubTypes, quickStatuses } = this.state;
      const childProps = {
        quickVendors,
        quickSubTypes,
        quickStatuses,
        ...props,
      };
      return React.createElement(DecoratedComponent, childProps, children);
    }
  }

  return WithQuickSubOptions;
};

export default withQuickSubOptions;
